import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import {
  loadTemplate,
  loadTemplateArchiveFolderStructure,
  loadTemplateInitializePayload,
} from '~src/services/api/templates';
import { DbFolder, DbProject } from '~src/types/db';

export const useTemplate = (
  projectId: number,
  templateId: string | null,
  enabled = true
) => {
  return useQuery<DbProject, AxiosError>(
    ['template', { projectId, templateId }],
    loadTemplate,
    {
      enabled: enabled && !!templateId && !!projectId,
    }
  );
};

export const useTemplateArchiveFolderStructure = (
  projectId: number,
  templateId: string | null,
  enabled = true
) => {
  return useQuery<DbFolder[], AxiosError>(
    ['templateArchiveFolderStructure', { projectId, templateId }],
    loadTemplateArchiveFolderStructure,
    {
      enabled: enabled && !!templateId && !!projectId,
    }
  );
};
